function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var SvgObservacionesSolicitud = function SvgObservacionesSolicitud(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BCF0F6"
    },
    cx: 100,
    cy: 100,
    r: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.445,
    y: 35,
    style: {
      fill: "#FFEDEE"
    },
    width: 101.109,
    height: 130
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.445,
    y: 35,
    style: {
      fill: "#D5007F"
    },
    width: 101.109,
    height: 17.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 64.336,
    style: {
      fill: "#9B4B4E"
    },
    width: 78,
    height: 8.668
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 84.559,
    style: {
      fill: "#9B4B4E"
    },
    width: 78,
    height: 8.668
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 125.004,
    style: {
      fill: "#9B4B4E"
    },
    width: 78,
    height: 8.668
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 104.781,
    style: {
      fill: "#9B4B4E"
    },
    width: 78,
    height: 8.667
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF8288"
    },
    cx: 150.555,
    cy: 133.672,
    r: 25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.555,
    y: 117.672,
    style: {
      fill: "#FFFFFF"
    },
    width: 8,
    height: 18
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 150.555,
    cy: 144.672,
    r: 5
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgObservacionesSolicitud, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/observacionesSolicitud.cde2f491.svg";
export { ForwardRef as ReactComponent };